import styled from '@emotion/styled';
import kebabCase from 'lodash/kebabCase';
import PropTypes from 'prop-types';

import { BasicContent } from './BasicContent';
import RichText from './RichText';
import { Mobile } from './internals/Devices';
import createSizes from './utilities/sizes';
import { Screens } from '../../PageBuilder/editing/Viewport';
import Dropdown from '../oc-dropdown';

const Sizes = createSizes({
  m: { [Mobile]: 345 },
});

const AccordionWrapper = styled.div`
  display: flex;
  justify-content: ${props => (props.alignment === 'Left' ? 'flex-start' : 'center')};
`;

const AccordionContainer = styled.div`
  margin: 0;
  width: ${({ width }) => `${width.Mobile}px`};
  @media (min-width: ${Screens.Tablet}px) {
    width: ${({ width }) => `${width.Tablet}px`};
  }
  @media (min-width: ${Screens.Desktop}px) {
    width: ${({ width }) => `${width.Desktop}px`};
  }
`;

// two accordions can carry the same title on one page, and the panel ids have to differ
const titled = accordions => {
  const seen = {};

  return (accordions || [])
    .filter(acc => acc?.title)
    .map(acc => {
      const slug = kebabCase(acc.title);
      seen[slug] = (seen[slug] || 0) + 1;

      return { ...acc, id: `accordion-${slug}-${seen[slug]}` };
    });
};

const CMSAccordion = ({ accordions, copy, containerSize, alignment, analytics }) => {
  const size = containerSize?.selection || 'xl';
  const Width = Sizes[size];

  return (
    <AccordionWrapper alignment={alignment} data-am-region={analytics?.faq ? 'Frequently Asked Questions' : undefined}>
      <AccordionContainer width={Width} size={size}>
        <BasicContent {...copy} />

        {titled(accordions).map(acc => (
          <Dropdown key={acc.id} id={acc.id} label={acc.title}>
            <RichText content={acc?.content} />
          </Dropdown>
        ))}
      </AccordionContainer>
    </AccordionWrapper>
  );
};

CMSAccordion.propTypes = {
  analytics: PropTypes.shape({
    faq: PropTypes.bool,
  }),
};

CMSAccordion.defaultProps = {
  analytics: {
    faq: false,
  },
};

export default CMSAccordion;
